// Компас в полосе поездки — вход в тур.
//
// Стоит именно на экране редактирования: тур рассказывает про библиотеку,
// варианты и итог, то есть ровно про то, что человек видит вокруг кнопки.
// В самой полосе — слева от путешественников: там начинается ряд контролов
// поездки, и приглашение попадается на глаза раньше, чем работа с ней.
//
// Пока тур не открывали, кнопка тихо пульсирует. Иначе про неё не узнают:
// компас без подписи среди других иконок ничем не выделяется, а тур —
// единственное место, где объясняется, зачем всё остальное.
import type { ReactElement } from 'react';
import { useT } from '../i18n';
import { useIsMobile } from '../ui/shell';
import { useOnboarding } from './OnboardingProvider';
import styles from './OnboardingButton.module.css';

/** Компас: соседние иконки полосы — про поездку, эта про то, куда идти. */
function CompassIcon(): ReactElement {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <circle cx="12" cy="12" r="9" />
      <path d="M15.4 8.6 13.6 13.6 8.6 15.4 10.4 10.4z" />
    </svg>
  );
}

export function OnboardingButton(): ReactElement {
  const t = useT();
  const { open, seen, start } = useOnboarding();
  // В бургер-меню кнопка стоит строкой во всю ширину и без подписи потеряется
  // среди соседей: под пальцем подсказки, объясняющей компас, нет.
  const isMobile = useIsMobile();

  const className = [
    'btn',
    isMobile ? '' : 'btn-sm',
    styles.tourBtn,
    isMobile ? styles.tourRow : '',
    seen ? '' : styles.pulse,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      type="button"
      className={className}
      aria-haspopup="dialog"
      aria-expanded={open}
      aria-label={isMobile ? undefined : t('onboarding.title')}
      title={t('onboarding.tip')}
      onClick={start}
    >
      <CompassIcon />
      {isMobile && <span>{t('onboarding.title')}</span>}
    </button>
  );
}
